import utcToZonedTime from 'date-fns-tz/utcToZonedTime'
import format from 'date-fns/format'

// @TODO: refactor overly-complex boolean expression
const scheduleInPageIsFilled = data => {
  return data && data.frequency && data.hoursPerAppointment && data.date
}

// @TODO: refactor overly-complex boolean expression
const scheduleFromBackendIsFilled = data => {
  return (
    data &&
    data.booking_type &&
    data.frequency &&
    data.duration &&
    data.first_appointment.is_flexible
  )
}

export default {
  getIsScheduleFilled: state => () => {
    if (
      scheduleInPageIsFilled(state.schedulePageData) ||
      scheduleFromBackendIsFilled(state.scheduleFromBE)
    ) {
      return true
    }

    return false
  },

  getSchedule: state => () => {
    if (!state.scheduleFromBE) {
      return state.schedulePageData
    }

    const firstAppointmentDate = utcToZonedTime(
      state.scheduleFromBE.first_appointment.date,
      'Europe/Berlin',
    )
    const formattedDate = format(firstAppointmentDate, 'yyyy-MM-dd')
    const formattedTime = state.scheduleFromBE.first_appointment.is_all_day
      ? null
      : format(firstAppointmentDate, 'HH:mm')

    state.schedulePageData.frequency = state.scheduleFromBE.booking_type
    state.schedulePageData.frequencyInfo = state.scheduleFromBE.frequency
    state.schedulePageData.hoursPerAppointment = `${state.scheduleFromBE.duration
      .toString()
      .replace('.', ',')} h`
    state.schedulePageData.date = formattedDate
    state.schedulePageData.time = formattedTime
    state.schedulePageData.flexibility =
      state.scheduleFromBE.first_appointment.is_flexible
    state.schedulePageData.recurringAppointmentsFlexibility =
      state.scheduleFromBE.expected_appointment_schedule &&
      state.scheduleFromBE.expected_appointment_schedule.is_flexible
    state.schedulePageData.specificTimesInfo =
      state.scheduleFromBE.expected_appointment_schedule &&
      state.scheduleFromBE.expected_appointment_schedule.preferences
    state.scheduleFromBE = null

    return state.schedulePageData
  },
}
